import React, { useState, useEffect } from 'react';
import { 
  TrendingUp, Package, Users, BarChart3, MessageSquare, 
  Zap, ShoppingBag, Target, Play, CheckCircle2, 
  ArrowRight, Menu, X, Bot, Sparkles, Bell,
  FileText, Settings, CreditCard, Share2, Megaphone,
  Calendar, DollarSign, ChevronRight, Lock, Unlock,
  Activity, PieChart, Layers, Coffee, Heart, Star
} from 'lucide-react';

const BrandSendiriPlatform = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isOwner, setIsOwner] = useState(false);
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const [activeTab, setActiveTab] = useState('dashboard');
  const [userPackage, setUserPackage] = useState('starter');
  const [showNotification, setShowNotification] = useState(false);
  const [marketData, setMarketData] = useState(null);
  const [pendingApprovals, setPendingApprovals] = useState(3);
  
  // Simulate market data fetching
  useEffect(() => {
    const timer = setTimeout(() => {
      setMarketData({
        tiktok: [
          { product: "Minuman Collagen", trend: "+156%", viral: true },
          { product: "Serum Vitamin C", trend: "+89%", viral: true },
          { product: "Kopi Diet", trend: "+234%", viral: true }
        ],
        shopee: [
          { product: "Salep Gatal", sales: "45.2K", growth: "+67%" },
          { product: "Minyak Telon Premium", sales: "38.9K", growth: "+45%" }
        ]
      });
    }, 1500);
    return () => clearTimeout(timer);
  }, []);

  const packages = [
    {
      name: "Starter",
      price: "2.5 Juta",
      features: ["1 Produk Maklon", "Tool Basic", "2 Konten/Bulan", "Support Email"],
      color: "from-blue-400 to-blue-600"
    },
    {
      name: "Growing",
      price: "5.5 Juta", 
      features: ["3 Produk Maklon", "Full Tool Access", "6 Konten + 2x Ads", "Priority Support"],
      color: "from-purple-400 to-purple-600",
      popular: true
    },
    {
      name: "Pro",
      price: "12 Juta",
      features: ["Unlimited Produk", "All Features", "Daily Reports", "Dedicated Team"],
      color: "from-orange-400 to-red-600"
    }
  ];

  const NavBar = () => (
    <nav className="fixed top-0 w-full bg-black/90 backdrop-blur-lg z-50 border-b border-white/10">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center space-x-2">
            <div className="w-10 h-10 bg-gradient-to-br from-purple-500 to-pink-500 rounded-xl flex items-center justify-center">
              <Package className="w-6 h-6 text-white" />
            </div>
            <span className="text-xl font-bold text-white">BrandSendiri.id</span>
          </div>
          
          <div className="hidden md:flex items-center space-x-8">
            <a href="#" className="text-gray-300 hover:text-white transition">Layanan</a>
            <a href="#" className="text-gray-300 hover:text-white transition">Produk</a>
            <a href="#" className="text-gray-300 hover:text-white transition">Harga</a>
            <a href="#" className="text-gray-300 hover:text-white transition">Tentang</a>
          </div>

          <div className="flex items-center space-x-4">
            {!isLoggedIn ? (
              <>
                <button 
                  onClick={() => setIsLoggedIn(true)}
                  className="px-4 py-2 text-white hover:text-gray-300 transition"
                >
                  Masuk
                </button>
                <button className="px-6 py-2 bg-gradient-to-r from-purple-500 to-pink-500 text-white rounded-full hover:shadow-lg hover:shadow-purple-500/25 transition transform hover:scale-105">
                  Daftar Gratis
                </button>
              </>
            ) : (
              <div className="flex items-center space-x-4">
                <Bell className="w-5 h-5 text-gray-300 cursor-pointer hover:text-white" />
                <div className="w-8 h-8 bg-gradient-to-br from-green-400 to-blue-500 rounded-full" />
              </div>
            )}
            
            <button
              onClick={() => setShowMobileMenu(!showMobileMenu)}
              className="md:hidden text-white"
            >
              {showMobileMenu ? <X /> : <Menu />}
            </button>
          </div>
        </div>
      </div>
    </nav>
  );

  const HeroSection = () => (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-black">
      <div className="absolute inset-0 bg-gradient-to-br from-purple-900/20 via-black to-pink-900/20" />
      
      {/* Animated background elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-20 left-20 w-72 h-72 bg-purple-500/20 rounded-full blur-3xl animate-pulse" />
        <div className="absolute bottom-20 right-20 w-96 h-96 bg-pink-500/20 rounded-full blur-3xl animate-pulse delay-1000" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 text-center">
        <div className="inline-flex items-center space-x-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full mb-8 animate-fade-in">
          <Sparkles className="w-4 h-4 text-yellow-400" />
          <span className="text-sm text-gray-300">Platform Maklon #1 dengan AI Assistant</span>
        </div>
        
        <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 animate-fade-in-up">
          Bikin Brand Sendiri
          <span className="block text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-pink-400">
            Tanpa Ribet, Full Otomatis
          </span>
        </h1>
        
        <p className="text-xl text-gray-300 mb-12 max-w-3xl mx-auto animate-fade-in-up delay-200">
          AI Market Analyst + Auto Marketing + Dashboard Pintar. 
          Anda cuma approve, sisanya biar AI yang kerjakan!
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center animate-fade-in-up delay-300">
          <button 
            onClick={() => setIsLoggedIn(true)}
            className="group px-8 py-4 bg-gradient-to-r from-purple-500 to-pink-500 text-white rounded-full hover:shadow-xl hover:shadow-purple-500/25 transition transform hover:scale-105 flex items-center justify-center space-x-2"
          >
            <span className="font-semibold">Mulai Gratis</span>
            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition" />
          </button>
          
          <button className="px-8 py-4 bg-white/10 backdrop-blur-sm text-white rounded-full hover:bg-white/20 transition flex items-center justify-center space-x-2">
            <Play className="w-5 h-5" />
            <span>Lihat Demo</span>
          </button>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mt-20 animate-fade-in-up delay-500">
          {[
            { icon: TrendingUp, label: "AI Market Analyst", value: "Real-time" },
            { icon: Bot, label: "WA Bot Assistant", value: "24/7" },
            { icon: Target, label: "Auto Marketing", value: "5 Platform" },
            { icon: Package, label: "Produk Maklon", value: "200+" }
          ].map((stat, i) => (
            <div key={i} className="text-center group">
              <div className="w-16 h-16 bg-white/10 backdrop-blur-sm rounded-2xl flex items-center justify-center mx-auto mb-3 group-hover:scale-110 transition">
                <stat.icon className="w-8 h-8 text-purple-400" />
              </div>
              <div className="text-2xl font-bold text-white mb-1">{stat.value}</div>
              <div className="text-sm text-gray-400">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );

  const Dashboard = () => (
    <div className="min-h-screen bg-gray-950 pt-16">
      <div className="flex">
        {/* Sidebar */}
        <div className="w-64 bg-gray-900 border-r border-gray-800 min-h-screen p-6">
          <div className="mb-8">
            <div className="text-sm text-gray-400 mb-2">Paket Anda</div>
            <div className="flex items-center space-x-2">
              <div className={`px-3 py-1 rounded-full text-sm font-medium ${
                userPackage === 'pro' ? 'bg-orange-500/20 text-orange-400' :
                userPackage === 'growing' ? 'bg-purple-500/20 text-purple-400' :
                'bg-blue-500/20 text-blue-400'
              }`}>
                {userPackage.charAt(0).toUpperCase() + userPackage.slice(1)}
              </div>
              {userPackage !== 'pro' && (
                <button className="text-xs text-gray-400 hover:text-white transition">
                  Upgrade <ChevronRight className="w-3 h-3 inline" />
                </button>
              )}
            </div>
          </div>

          <nav className="space-y-2">
            {[
              { icon: PieChart, label: 'Dashboard', id: 'dashboard' },
              { icon: TrendingUp, label: 'Market Intelligence', id: 'market', badge: 'New' },
              { icon: Bot, label: 'AI Assistant', id: 'assistant' },
              { icon: Package, label: 'Produk Saya', id: 'products' },
              { icon: Megaphone, label: 'Marketing Tools', id: 'marketing' },
              { icon: BarChart3, label: 'Analytics', id: 'analytics' },
              { icon: Settings, label: 'Pengaturan', id: 'settings' }
            ].map(item => (
              <button
                key={item.id}
                onClick={() => setActiveTab(item.id)}
                className={`w-full flex items-center space-x-3 px-4 py-3 rounded-lg transition ${
                  activeTab === item.id 
                    ? 'bg-purple-500/20 text-purple-400' 
                    : 'text-gray-400 hover:bg-gray-800 hover:text-white'
                }`}
              >
                <item.icon className="w-5 h-5" />
                <span className="flex-1 text-left">{item.label}</span>
                {item.badge && (
                  <span className="px-2 py-1 bg-purple-500 text-xs text-white rounded-full">
                    {item.badge}
                  </span>
                )}
              </button>
            ))}
          </nav>

          {isOwner && (
            <div className="mt-8 p-4 bg-yellow-500/10 border border-yellow-500/20 rounded-lg">
              <div className="flex items-center space-x-2 text-yellow-400 mb-2">
                <Bell className="w-5 h-5" />
                <span className="font-medium">Owner Mode</span>
              </div>
              <div className="text-sm text-gray-400">
                {pendingApprovals} pending approvals
              </div>
            </div>
          )}
        </div>

        {/* Main Content */}
        <div className="flex-1 p-8">
          {activeTab === 'dashboard' && <DashboardContent />}
          {activeTab === 'market' && <MarketIntelligence />}
          {activeTab === 'assistant' && <AIAssistant />}
          {activeTab === 'marketing' && <MarketingTools />}
        </div>
      </div>
    </div>
  );

  const DashboardContent = () => (
    <div className="space-y-6">
      <div className="flex justify-between items-center mb-8">
        <div>
          <h1 className="text-3xl font-bold text-white mb-2">Dashboard Overview</h1>
          <p className="text-gray-400">Selamat datang kembali! Berikut ringkasan bisnis Anda.</p>
        </div>
        <button 
          onClick={() => setIsOwner(!isOwner)}
          className="px-4 py-2 bg-purple-500/20 text-purple-400 rounded-lg hover:bg-purple-500/30 transition"
        >
          {isOwner ? 'User View' : 'Owner View'}
        </button>
      </div>

      {/* Stats Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {[
          { label: 'Total Produk', value: '3', icon: Package, change: '+2 bulan ini', color: 'purple' },
          { label: 'Konten Dibuat', value: '24', icon: FileText, change: '+8 minggu ini', color: 'blue' },
          { label: 'Campaign Aktif', value: '5', icon: Megaphone, change: '3 berjalan', color: 'green' },
          { label: 'Total Revenue', value: '45.2 Jt', icon: DollarSign, change: '+23% vs bulan lalu', color: 'orange' }
        ].map((stat, i) => (
          <div key={i} className="bg-gray-900 border border-gray-800 rounded-xl p-6 hover:border-gray-700 transition">
            <div className="flex items-center justify-between mb-4">
              <div className={`w-12 h-12 bg-${stat.color}-500/20 rounded-lg flex items-center justify-center`}>
                <stat.icon className={`w-6 h-6 text-${stat.color}-400`} />
              </div>
              <span className="text-xs text-gray-500">{stat.change}</span>
            </div>
            <div className="text-2xl font-bold text-white mb-1">{stat.value}</div>
            <div className="text-sm text-gray-400">{stat.label}</div>
          </div>
        ))}
      </div>

      {/* Recent Activity */}
      <div className="bg-gray-900 border border-gray-800 rounded-xl p-6">
        <h3 className="text-lg font-semibold text-white mb-4">Aktivitas Terbaru</h3>
        <div className="space-y-4">
          {[
            { action: 'AI Market Analysis selesai', time: '5 menit lalu', icon: TrendingUp, status: 'success' },
            { action: 'Konten TikTok dibuat', time: '1 jam lalu', icon: FileText, status: 'success' },
            { action: 'Campaign Facebook dimulai', time: '3 jam lalu', icon: Megaphone, status: 'active' },
            { action: 'Produk baru ditambahkan', time: 'Kemarin', icon: Package, status: 'info' }
          ].map((activity, i) => (
            <div key={i} className="flex items-center space-x-4 p-4 bg-gray-800/50 rounded-lg hover:bg-gray-800 transition">
              <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${
                activity.status === 'success' ? 'bg-green-500/20' :
                activity.status === 'active' ? 'bg-blue-500/20' :
                'bg-gray-700'
              }`}>
                <activity.icon className={`w-5 h-5 ${
                  activity.status === 'success' ? 'text-green-400' :
                  activity.status === 'active' ? 'text-blue-400' :
                  'text-gray-400'
                }`} />
              </div>
              <div className="flex-1">
                <div className="text-white font-medium">{activity.action}</div>
                <div className="text-sm text-gray-400">{activity.time}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );

  const MarketIntelligence = () => (
    <div className="space-y-6">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-white mb-2">Market Intelligence Tool</h1>
        <p className="text-gray-400">Analisis real-time dari berbagai platform untuk membantu keputusan bisnis Anda</p>
      </div>

      {/* Platform Tabs */}
      <div className="flex space-x-4 mb-6">
        {['TikTok', 'Shopee', 'Tokopedia', 'Instagram', 'Lazada'].map(platform => (
          <button
            key={platform}
            className="px-6 py-3 bg-gray-900 border border-gray-800 rounded-lg hover:border-purple-500 hover:bg-purple-500/10 transition flex items-center space-x-2"
          >
            <span className="text-white">{platform}</span>
            {platform === 'TikTok' && <span className="text-xs bg-red-500 text-white px-2 py-1 rounded-full">HOT</span>}
          </button>
        ))}
      </div>

      {/* Market Data Display */}
      {marketData && (
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <div className="bg-gray-900 border border-gray-800 rounded-xl p-6">
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-lg font-semibold text-white">Trending di TikTok</h3>
              <span className="text-xs text-gray-400">Update: 5 menit lalu</span>
            </div>
            <div className="space-y-3">
              {marketData.tiktok.map((item, i) => (
                <div key={i} className="flex items-center justify-between p-4 bg-gray-800/50 rounded-lg hover:bg-gray-800 transition">
                  <div className="flex items-center space-x-3">
                    <div className="text-2xl">{i + 1}</div>
                    <div>
                      <div className="text-white font-medium">{item.product}</div>
                      <div className="text-sm text-gray-400">Kategori: Kesehatan</div>
                    </div>
                  </div>
                  <div className="text-right">
                    <div className="text-green-400 font-semibold">{item.trend}</div>
                    {item.viral && <span className="text-xs bg-red-500 text-white px-2 py-1 rounded-full">VIRAL</span>}
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="bg-gray-900 border border-gray-800 rounded-xl p-6">
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-lg font-semibold text-white">Best Seller Shopee</h3>
              <span className="text-xs text-gray-400">Update: 10 menit lalu</span>
            </div>
            <div className="space-y-3">
              {marketData.shopee.map((item, i) => (
                <div key={i} className="flex items-center justify-between p-4 bg-gray-800/50 rounded-lg hover:bg-gray-800 transition">
                  <div className="flex items-center space-x-3">
                    <div className="text-2xl">{i + 1}</div>
                    <div>
                      <div className="text-white font-medium">{item.product}</div>
                      <div className="text-sm text-gray-400">Terjual: {item.sales}</div>
                    </div>
                  </div>
                  <div className="text-right">
                    <div className="text-green-400 font-semibold">{item.growth}</div>
                    <div className="text-xs text-gray-400">growth</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* Recommendation Section */}
      <div className="bg-gradient-to-r from-purple-900/20 to-pink-900/20 border border-purple-500/20 rounded-xl p-6">
        <div className="flex items-start space-x-4">
          <div className="w-12 h-12 bg-purple-500/20 rounded-lg flex items-center justify-center flex-shrink-0">
            <Sparkles className="w-6 h-6 text-purple-400" />
          </div>
          <div className="flex-1">
            <h3 className="text-lg font-semibold text-white mb-2">AI Recommendation</h3>
            <p className="text-gray-300 mb-4">
              Berdasarkan analisis pasar, kami merekomendasikan Anda untuk fokus pada produk 
              <span className="text-purple-400 font-semibold"> Minuman Collagen </span>
              dengan target pasar wanita 25-35 tahun melalui TikTok Ads. Potensi ROI: 320%
            </p>
            <button className="px-6 py-2 bg-purple-500 text-white rounded-lg hover:bg-purple-600 transition">
              Mulai Produksi Produk Ini
            </button>
          </div>
        </div>
      </div>
    </div>
  );

  const AIAssistant = () => (
    <div className="space-y-6">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-white mb-2">AI Marketing Assistant</h1>
        <p className="text-gray-400">Asisten pintar untuk membantu semua kebutuhan marketing Anda</p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        {/* Quick Actions */}
        <div className="lg:col-span-2 space-y-4">
          <div className="bg-gray-900 border border-gray-800 rounded-xl p-6">
            <h3 className="text-lg font-semibold text-white mb-4">Quick Actions</h3>
            <div className="grid grid-cols-2 gap-4">
              {[
                { icon: FileText, label: 'Buat Konten', desc: 'TikTok, IG, FB' },
                { icon: Target, label: 'Setup Ads', desc: 'Multi-platform' },
                { icon: PieChart, label: 'Analisis Kompetitor', desc: 'Real-time data' },
                { icon: MessageSquare, label: 'Caption Generator', desc: 'AI Powered' }
              ].map((action, i) => (
                <button key={i} className="p-4 bg-gray-800 rounded-lg hover:bg-gray-700 transition text-left group">
                  <div className="flex items-center space-x-3 mb-2">
                    <div className="w-10 h-10 bg-purple-500/20 rounded-lg flex items-center justify-center group-hover:scale-110 transition">
                      <action.icon className="w-5 h-5 text-purple-400" />
                    </div>
                    <div>
                      <div className="text-white font-medium">{action.label}</div>
                      <div className="text-xs text-gray-400">{action.desc}</div>
                    </div>
                  </div>
                </button>
              ))}
            </div>
          </div>

          {/* Chat Interface */}
          <div className="bg-gray-900 border border-gray-800 rounded-xl p-6">
            <div className="flex items-center space-x-3 mb-4">
              <Bot className="w-6 h-6 text-purple-400" />
              <h3 className="text-lg font-semibold text-white">Chat dengan AI Assistant</h3>
            </div>
            
            <div className="space-y-4 mb-4 max-h-64 overflow-y-auto">
              <div className="flex items-start space-x-3">
                <div className="w-8 h-8 bg-purple-500/20 rounded-full flex items-center justify-center">
                  <Bot className="w-4 h-4 text-purple-400" />
                </div>
                <div className="flex-1 bg-gray-800 rounded-lg p-3">
                  <p className="text-gray-300 text-sm">
                    Halo! Saya AI Assistant Anda. Bagaimana saya bisa membantu marketing produk Anda hari ini?
                  </p>
                </div>
              </div>
            </div>

            <div className="flex space-x-2">
              <input
                type="text"
                placeholder="Ketik pesan Anda..."
                className="flex-1 px-4 py-2 bg-gray-800 border border-gray-700 rounded-lg text-white placeholder-gray-400 focus:outline-none focus:border-purple-500"
              />
              <button className="px-4 py-2 bg-purple-500 text-white rounded-lg hover:bg-purple-600 transition">
                Kirim
              </button>
            </div>
          </div>
        </div>

        {/* Assistant Stats */}
        <div className="space-y-4">
          <div className="bg-gray-900 border border-gray-800 rounded-xl p-6">
            <h3 className="text-lg font-semibold text-white mb-4">Assistant Stats</h3>
            <div className="space-y-4">
              <div>
                <div className="flex justify-between text-sm mb-1">
                  <span className="text-gray-400">Konten Dibuat</span>
                  <span className="text-white">24/30</span>
                </div>
                <div className="w-full bg-gray-800 rounded-full h-2">
                  <div className="bg-purple-500 h-2 rounded-full" style={{width: '80%'}} />
                </div>
              </div>
              <div>
                <div className="flex justify-between text-sm mb-1">
                  <span className="text-gray-400">Ads Running</span>
                  <span className="text-white">3/5</span>
                </div>
                <div className="w-full bg-gray-800 rounded-full h-2">
                  <div className="bg-blue-500 h-2 rounded-full" style={{width: '60%'}} />
                </div>
              </div>
              <div>
                <div className="flex justify-between text-sm mb-1">
                  <span className="text-gray-400">AI Credits</span>
                  <span className="text-white">450/500</span>
                </div>
                <div className="w-full bg-gray-800 rounded-full h-2">
                  <div className="bg-green-500 h-2 rounded-full" style={{width: '90%'}} />
                </div>
              </div>
            </div>
          </div>

          <div className="bg-gradient-to-br from-purple-900/20 to-pink-900/20 border border-purple-500/20 rounded-xl p-6">
            <h4 className="text-white font-semibold mb-2">💡 Pro Tip</h4>
            <p className="text-sm text-gray-300">
              Gunakan AI Assistant untuk membuat konten viral dengan menggabungkan trend terkini dan USP produk Anda.
            </p>
          </div>
        </div>
      </div>
    </div>
  );

  const MarketingTools = () => (
    <div className="space-y-6">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-white mb-2">Marketing Tools</h1>
        <p className="text-gray-400">Semua tools yang Anda butuhkan untuk memasarkan produk</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {[
          {
            title: "Content Creator",
            icon: FileText,
            desc: "Buat konten menarik untuk semua platform",
            action: "Buat Konten",
            color: "purple"
          },
          {
            title: "Ads Manager", 
            icon: Megaphone,
            desc: "Kelola iklan di TikTok, Meta, Google",
            action: "Setup Campaign",
            color: "blue"
          },
          {
            title: "Auto Scheduler",
            icon: Calendar,
            desc: "Jadwalkan posting otomatis",
            action: "Atur Jadwal",
            color: "green"
          },
          {
            title: "Hashtag Research",
            icon: Target,
            desc: "Temukan hashtag viral & relevan",
            action: "Research Now",
            color: "orange"
          },
          {
            title: "Competitor Analysis",
            icon: PieChart,
            desc: "Analisis strategi kompetitor",
            action: "Mulai Analisis",
            color: "red"
          },
          {
            title: "ROI Calculator",
            icon: DollarSign,
            desc: "Hitung potensi keuntungan",
            action: "Hitung ROI",
            color: "yellow"
          }
        ].map((tool, i) => (
          <div key={i} className="bg-gray-900 border border-gray-800 rounded-xl p-6 hover:border-gray-700 transition group">
            <div className={`w-12 h-12 bg-${tool.color}-500/20 rounded-lg flex items-center justify-center mb-4 group-hover:scale-110 transition`}>
              <tool.icon className={`w-6 h-6 text-${tool.color}-400`} />
            </div>
            <h3 className="text-lg font-semibold text-white mb-2">{tool.title}</h3>
            <p className="text-sm text-gray-400 mb-4">{tool.desc}</p>
            <button className={`w-full px-4 py-2 bg-${tool.color}-500/20 text-${tool.color}-400 rounded-lg hover:bg-${tool.color}-500/30 transition`}>
              {tool.action}
            </button>
          </div>
        ))}
      </div>

      {/* Recent Campaigns */}
      <div className="bg-gray-900 border border-gray-800 rounded-xl p-6">
        <h3 className="text-lg font-semibold text-white mb-4">Campaign Aktif</h3>
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="text-left text-sm text-gray-400 border-b border-gray-800">
                <th className="pb-3">Campaign</th>
                <th className="pb-3">Platform</th>
                <th className="pb-3">Status</th>
                <th className="pb-3">Performance</th>
                <th className="pb-3">Action</th>
              </tr>
            </thead>
            <tbody className="text-sm">
              <tr className="border-b border-gray-800/50">
                <td className="py-4">
                  <div className="text-white font-medium">Promo Collagen Drink</div>
                  <div className="text-xs text-gray-400">Started 3 days ago</div>
                </td>
                <td className="py-4">
                  <div className="flex items-center space-x-2">
                    <span className="text-gray-300">TikTok Ads</span>
                  </div>
                </td>
                <td className="py-4">
                  <span className="px-3 py-1 bg-green-500/20 text-green-400 rounded-full text-xs">Active</span>
                </td>
                <td className="py-4">
                  <div className="text-white">CTR: 4.2%</div>
                  <div className="text-xs text-gray-400">↑ 23% vs avg</div>
                </td>
                <td className="py-4">
                  <button className="text-purple-400 hover:text-purple-300 transition">
                    View Details →
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );

  return (
    <div className="min-h-screen bg-black text-white">
      <style jsx>{`
        @keyframes fade-in {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        
        @keyframes fade-in-up {
          from { 
            opacity: 0;
            transform: translateY(20px);
          }
          to { 
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        .animate-fade-in {
          animation: fade-in 0.6s ease-out;
        }
        
        .animate-fade-in-up {
          animation: fade-in-up 0.8s ease-out;
        }
        
        .delay-200 { animation-delay: 200ms; }
        .delay-300 { animation-delay: 300ms; }
        .delay-500 { animation-delay: 500ms; }
        .delay-1000 { animation-delay: 1000ms; }
      `}</style>
      
      <NavBar />
      
      {!isLoggedIn ? (
        <>
          <HeroSection />
          
          {/* Features Section */}
          <section className="py-20 bg-gray-950">
            <div className="max-w-7xl mx-auto px-4">
              <div className="text-center mb-16">
                <h2 className="text-4xl font-bold text-white mb-4">
                  Platform All-in-One untuk Bisnis Maklon
                </h2>
                <p className="text-xl text-gray-400 max-w-3xl mx-auto">
                  Dari analisis pasar hingga eksekusi marketing, semua otomatis dengan AI
                </p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                {[
                  {
                    icon: TrendingUp,
                    title: "AI Market Analyst",
                    desc: "Analisis real-time dari TikTok, Shopee, Tokopedia untuk temukan produk trending",
                    features: ["Trend Analysis", "Competitor Research", "Price Monitoring"]
                  },
                  {
                    icon: Bot,
                    title: "Marketing Assistant",
                    desc: "AI yang bantu buat konten, setup ads, dan distribusi otomatis",
                    features: ["Content Creation", "Auto Ads", "Multi-platform"]
                  },
                  {
                    icon: Package,
                    title: "Product Management",
                    desc: "Kelola produk maklon dari produksi hingga marketing dalam satu platform",
                    features: ["Production Tracking", "Inventory", "Quality Control"]
                  }
                ].map((feature, i) => (
                  <div key={i} className="bg-gray-900 border border-gray-800 rounded-2xl p-8 hover:border-purple-500/50 transition group">
                    <div className="w-14 h-14 bg-purple-500/20 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition">
                      <feature.icon className="w-7 h-7 text-purple-400" />
                    </div>
                    <h3 className="text-xl font-semibold text-white mb-3">{feature.title}</h3>
                    <p className="text-gray-400 mb-6">{feature.desc}</p>
                    <ul className="space-y-2">
                      {feature.features.map((item, j) => (
                        <li key={j} className="flex items-center space-x-2 text-sm text-gray-300">
                          <CheckCircle2 className="w-4 h-4 text-green-400" />
                          <span>{item}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* Pricing Section */}
          <section className="py-20 bg-black">
            <div className="max-w-7xl mx-auto px-4">
              <div className="text-center mb-16">
                <h2 className="text-4xl font-bold text-white mb-4">
                  Pilih Paket Sesuai Kebutuhan
                </h2>
                <p className="text-xl text-gray-400">
                  Mulai dari paket starter hingga enterprise, semua dengan AI Assistant
                </p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                {packages.map((pkg, i) => (
                  <div key={i} className={`relative bg-gray-900 border ${pkg.popular ? 'border-purple-500' : 'border-gray-800'} rounded-2xl p-8 hover:scale-105 transition`}>
                    {pkg.popular && (
                      <div className="absolute -top-4 left-1/2 -translate-x-1/2 px-4 py-1 bg-purple-500 text-white text-sm rounded-full">
                        Most Popular
                      </div>
                    )}
                    <div className={`w-16 h-16 bg-gradient-to-br ${pkg.color} rounded-xl flex items-center justify-center mb-6`}>
                      <Package className="w-8 h-8 text-white" />
                    </div>
                    <h3 className="text-2xl font-bold text-white mb-2">{pkg.name}</h3>
                    <div className="text-3xl font-bold text-white mb-1">
                      Rp {pkg.price}
                      <span className="text-sm text-gray-400 font-normal">/bulan</span>
                    </div>
                    <ul className="space-y-3 mb-8">
                      {pkg.features.map((feature, j) => (
                        <li key={j} className="flex items-center space-x-2 text-gray-300">
                          <CheckCircle2 className="w-5 h-5 text-green-400" />
                          <span>{feature}</span>
                        </li>
                      ))}
                    </ul>
                    <button className={`w-full py-3 rounded-lg font-semibold transition ${
                      pkg.popular 
                        ? 'bg-purple-500 text-white hover:bg-purple-600' 
                        : 'bg-gray-800 text-white hover:bg-gray-700'
                    }`}>
                      Pilih {pkg.name}
                    </button>
                  </div>
                ))}
              </div>
            </div>
          </section>
        </>
      ) : (
        <Dashboard />
      )}
    </div>
  );
};

export default BrandSendiriPlatform;